// src/pages/EtapesMarche.jsx
import React from 'react';
import Layout from '../layouts/Layout';
import Button from "../components/ui/Button";
import { useNavigate } from "react-router-dom";

import {
  VerticalTimeline,
  VerticalTimelineElement,
} from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';

const steps = [
  {
    title: 'En cours de rédaction du cahier des charges',
    subtitle: `L'initiateur`,
    desc: `L'initiateur doit rédiger le cahier des charges.`,
    type: 'commun',
    role: 'rédaction',
    multipleUser: false,
  },
  {
    title: "En attente d'approbation du cahier des charges par le manager",
    subtitle: 'Le manager',
    desc: 'Le manager doit valider le cahier des charges.',
    type: 'commun',
    role: 'validation',
    multipleUser: false,
  },
  {
    title: 'En attente du contrôle de conformité du cahier des charges par le directeur financier',
    subtitle: 'Le directeur financier',
    desc: 'Le directeur financier doit valider le cahier des charges.',
    type: 'commun',
    role: 'validation',
    multipleUser: false,
  },
  {
    title: `En attente d'approbation du cahier des charges par le DG`,
    subtitle: `Le directeur général`,
    desc: `Le directeur général doit valider le cahier des charges.`,
    type: `commun`,
    role: `validation`,
    multipleUser: false,
  },
  {
    title: `En attente d'approbation du cahier des charges par le Président et l'Administrateur du CA`,
    subtitle: `Le Président et l'Administrateur du CA`,
    desc: `Le directeur général doit valider le cahier des charges.`,
    type: `gros`,
    role: `validation`,
    multipleUser: true,
  },
  {
    title: `En attente de l'encodage du marché dans e-Procurement par le directeur financier`,
    subtitle: `Le directeur financier`,
    desc: `Le directeur financier doit encoder le marché dans e-Procurement.`,
    type: `gros`,
    role: `rédaction`,
    multipleUser: false,
  },
  {
    title: `En attente de la rédaction du rapport d'attribution par l'initiateur`,
    subtitle: `L'initiateur`,
    desc: `L'initiateur doit récolter les différentes soumissions et rédiger le rapport d'attribution.`,
    type: `commun`,
    role: `rédaction`,
    multipleUser: false,
  },
  {
    title: `En attente de l'approbation du rapport d'attribution par le DG`,
    subtitle: `Le directeur général`,
    desc: `Le directeur général doit valider le rapport d'attribution.`,
    type: `commun`,
    role: `validation`,
    multipleUser: false,
  },
  {
    title: `En attente de l'approbation du rapport d'attribution par le Président et l'Administrateur du CA`,
    subtitle: `Le Président et l'Administrateur du CA`,
    desc: `Le Président du CA et un Administrateur du CA doivent valider le rapport d'attribution.`,
    type: `gros`,
    role: `validation`,
    multipleUser: true,
  },
  {
    title: `En attente de rédaction de la notification d'attribution par le directeur financier`,
    subtitle: `Le directeur financier`,
    desc: `Le directeur financier doit rédiger la notification d'attribution.`,
    type: `commun`,
    role: `rédaction`,
    multipleUser: false,
  },
  {
    title: `En attente de validation de la notification d'attribution par le directeur général`,
    subtitle: `Le directeur général`,
    desc: `Le directeur général doit signer la notification d'attribution.`,
    type: `commun`,
    role: `validation`,
    multipleUser: false,
  },
  {
    title: `Processus terminé`,
    subtitle: ``,
    desc: `Toutes les étapes du marché public ont été complétées.`,
    type: `commun`,
    role: `fin`,
    multipleUser: false,
  },
];

const roleIcons = {
  rédaction: '📝',
  validation: '🔎',
  fin: '✅',
};

export default function EtapesMarche() {
  const navigate = useNavigate();
  return (
    <Layout>
      <style>
        {`
          .vertical-timeline::before {
            width: 2px !important;
            background: #e91e63 !important;
            top: 20px !important;
            left: 50% !important;
            transform: translateX(-50%);
          }

          .vertical-timeline-element-icon {
            left: 50% !important;
            margin-left: -20px !important;
            box-shadow: none !important;
            border-radius: 50% !important;
            border: 2px solid #e91e63 !important;
            background: #fff !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            font-weight: bold !important;
            font-size: 15px !important;
            color: #e91e63 !important;
            z-index: 10 !important;
          }

          .back-button-container {
            position: sticky;
            top: 0;
            background-color: #ffffff;
            z-index: 100;
            padding: 20px;

            display: flex;
            justify-content: flex-end;
          }

          .title-box {
            position: absolute;
            right: 60%;
            top: -10px;
            width: 45vw;
            max-width: 420px;
            font-weight: bold;
            font-size: 16px;
            text-align: left;
            white-space: normal;
            z-index: 10;
            line-height: 1.2em;
            padding: 15px;
            color: #0d47a1;
            background-color: transparent;
            border-left: none;
            border-radius: 6px;
            box-shadow: none;
          }

          .title-box.final-step {
            color: #1b5e20;
            background-color: #e8f5e9;
            border-left: 5px solid #2e7d32;
            box-shadow: 0 0 8px rgba(76, 175, 80, 0.3);
          }

          .title-box.gros-step {
            color: #fb8c00;
            background-color: #fff3e0;
            border-left: 5px solid #fb8c00;
            box-shadow: 0 0 8px rgba(251, 140, 0, 0.3);
          }

          @media (max-width: 600px) {
            .title-box {
              position: static !important;
              width: auto !important;
              max-width: 100% !important;
              right: auto !important;
              top: auto !important;
              background-color: transparent !important;
              border-left: none !important;
              box-shadow: none !important;
              padding: 0 !important;
              font-size: 14px !important;
              margin-bottom: 0 !important;
              margin-left: 10px !important;
              color: #0d47a1 !important;
            }
          }


          .back-button-container {
  position: sticky;
  top: 0;
  background-color: #ffffff;
  z-index: 100;
  padding: 20px;

  display: flex;
  justify-content: flex-end;
}

/* Le bouton, position fixed par défaut */
.retour-liste-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  z-index: 1000;
}

/* En dessous de 1100px */
/* Le container perd son position sticky */
/* Le bouton passe en position static pour rester dans le flux */
@media (max-width: 1100px) {
  .back-button-container {
    position: static;
  }
  .retour-liste-button {
    position: static;
    margin: 20px 0;
  }
}

        `}
      </style>

      <div
        style={{
          height: 'calc(100vh - 120px)',
          overflowY: 'auto',
          padding: '0 20px 20px',
        }}
      >
        <div className="back-button-container">
          <Button
            onClick={() => navigate("/")}
            color="lightGray"
            size="small"
            className="retour-liste-button"
          >
            ← Retour à la liste
          </Button>
        </div>

        <div
          style={{
            maxWidth: '900px',
            margin: '0 auto',
            backgroundColor: '#ffffff',
            borderRadius: '12px',
          }}
        >
          <h1
            style={{
              textAlign: 'center',
              fontSize: '28px',
              fontWeight: 'bold',
              marginBottom: '40px',
              color: '#333',
              textTransform: 'uppercase',
              borderBottom: '2px solid #e91e63',
              paddingBottom: '10px',
              letterSpacing: '1px',
            }}
          >
            Processus du marché public
          </h1>

          <VerticalTimeline layout="1-column" lineColor="#e91e63">
            {steps.map((step, i) => {
              const isGrosMarcheOnly = step.type === 'gros';
              const isFinalStep = step.role === 'fin';

              const contentStyle = {
                background: isFinalStep
                  ? '#e8f5e9'
                  : isGrosMarcheOnly
                  ? '#fff3e0'
                  : '#e3f2fd',
                color: isFinalStep ? '#1b5e20' : '#0d47a1',
                textAlign: 'left',
                width: '460px',
                maxWidth: '460px',
                borderLeft: isGrosMarcheOnly
                  ? '5px solid #fb8c00'
                  : isFinalStep
                  ? '5px solid #2e7d32'
                  : 'none',
                boxShadow: isGrosMarcheOnly
                  ? '0 0 8px rgba(251, 140, 0, 0.5)'
                  : isFinalStep
                  ? '0 0 8px rgba(76, 175, 80, 0.4)'
                  : 'none',
                position: 'relative',
                left: 'calc(50% + 22px)',
                margin: 0,
                padding: '15px 20px',
                borderRadius: '8px',
              };

              const contentArrowStyle = {
                borderRight: 'none',
                borderLeft: `7px solid ${
                  isFinalStep ? '#e8f5e9' : isGrosMarcheOnly ? '#fff3e0' : '#e3f2fd'
                }`,
                left: '0',
                transform: 'translateX(0)',
                position: 'absolute',
                top: '20px',
                marginLeft: '-7px',
              };

              const iconStyle = {
                background: '#ffffff',
                color: isFinalStep ? '#2e7d32' : '#e91e63',
                border: `2px solid ${isFinalStep ? '#2e7d32' : '#e91e63'}`,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                fontSize: '15px',
                fontWeight: 'bold',
                width: '40px',
                height: '40px',
                position: 'relative',
                zIndex: 10,
                boxShadow: 'none',
                padding: '0',
                borderRadius: '50%',
                marginLeft: '0',
              };

              const titleBoxClass = isFinalStep ? 'title-box final-step' : isGrosMarcheOnly ? 'title-box gros-step' : 'title-box';

              return (
                <div key={i} style={{ position: 'relative', marginBottom: '50px' }}>
                  {step.title && (
                    <div className={titleBoxClass}>
                      {step.title}
                    </div>
                  )}

                  <VerticalTimelineElement
                    contentStyle={contentStyle}
                    contentArrowStyle={contentArrowStyle}
                    iconStyle={iconStyle}
                    icon={<div>{roleIcons[step.role] || '🔷'}</div>}
                    className={isFinalStep ? 'final-step' : isGrosMarcheOnly ? 'gros-step' : ''}
                  >
                    <div style={{ marginBottom: '12px' }}>
                      <b>Description</b>
                      <div>{step.desc}</div>
                    </div>

                    {!isFinalStep && step.subtitle && (
                      <div>
                        <b>Intervenant{step.multipleUser ? 's' : ''}</b>
                        <div>{step.subtitle}</div>
                      </div>
                    )}

                    {isGrosMarcheOnly && (
                      <div
                        style={{
                          marginTop: '10px',
                          fontSize: '12px',
                          color: '#fb8c00',
                          fontWeight: 'bold',
                          display: 'inline-block',
                          backgroundColor: '#ffe0b2',
                          padding: '4px 8px',
                          borderRadius: '4px',
                        }}
                      >
                        ⚠️ Étape uniquement pour les marchés à + de 30.000 €
                      </div>
                    )}
                  </VerticalTimelineElement>
                </div>
              );
            })}
          </VerticalTimeline>
        </div>
      </div>
    </Layout>
  );
}
